import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

export type CardVariant = "default" | "elevated" | "interactive" | "glass";
export type CardBodyPadding = "sm" | "md" | "lg";

const cardVariants: Record<CardVariant, string> = {
  default: "rounded-2xl border border-border bg-card/80 shadow-lg",
  elevated:
    "rounded-2xl border border-[var(--charity-stone)] bg-[var(--card)] shadow-[0_8px_24px_rgba(26,77,46,0.08)] dark:shadow-[0_8px_24px_rgba(0,0,0,0.25)]",
  interactive:
    "charity-interactive-card rounded-2xl border border-[var(--charity-stone)] bg-[var(--card)] shadow-[0_4px_16px_rgba(26,77,46,0.06)] transition-all duration-300 ease-[var(--ease-out-expo)] hover:-translate-y-1 hover:border-[var(--charity-green)]/30 hover:shadow-[0_12px_32px_rgba(46,125,50,0.12)] dark:hover:shadow-[0_12px_32px_rgba(0,0,0,0.35)]",
  glass:
    "charity-glass-panel rounded-3xl border border-[var(--charity-green)]/15 bg-[var(--card)]/70 shadow-[0_12px_40px_rgba(26,77,46,0.1)] backdrop-blur-[20px] dark:border-white/10 dark:bg-white/5 dark:shadow-[0_12px_40px_rgba(0,0,0,0.3)]",
};

const bodyPadding: Record<CardBodyPadding, string> = {
  sm: "p-3 md:p-4",
  md: "p-4 md:p-6",
  lg: "p-6 md:p-8",
};

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
}

export function Card({
  className,
  variant = "default",
  ...props
}: CardProps) {
  return (
    <div className={cn(cardVariants[variant], className)} {...props} />
  );
}

interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardBodyPadding;
}

export function CardBody({
  className,
  padding = "md",
  ...props
}: CardBodyProps) {
  return (
    <div className={cn(bodyPadding[padding], className)} {...props} />
  );
}
